import { render } from "./ClientsDataTable.vue?vue&type=template&id=39ab3466&scoped=true"
import script from "./ClientsDataTable.vue?vue&type=script&lang=js"
export * from "./ClientsDataTable.vue?vue&type=script&lang=js"

import "./ClientsDataTable.vue?vue&type=style&index=0&id=39ab3466&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ab3466"]])

export default __exports__